import $ from 'jquery'
export function getFooterInfo() {
  $("#year").text(new Date().getFullYear())

  $.ajax({
    url: `https://static.web.realmerit.com.cn/website/info.json?t=${new Date().getDay()}`,
    success(res) {
      $("#address").text(res.address)
      $("#QR_code").attr("src", res.qrcode)
      $("#phone").text(res.phone+' '+res.telephone)
      $("#mail").text(res.mail)
    }
  })
}
